import * as Yup from 'yup'
import { Form } from 'react-bootstrap'
import LocalizedStrings from 'react-localization';

import { ClientLanguage } from "../../../../../Api"

let locStrings = new LocalizedStrings({
    de:
    {
        dataProtectionRulesRequired: "Die Datenschutzbestimmungen müssen akzeptiert werden",
        dataProtectionRules: "Datenschutzbestimmungen",
        dataProtectionRulesRead: "* Ich habe die {dataProtectionRulesLink} zur Kenntnis genommen.",
    },
    en:
    {
        dataProtectionRulesRequired: "The privacy policy must be accepted",
        dataProtectionRules: "privacy policy",
        dataProtectionRulesRead: "* I have read the {dataProtectionRulesLink}.",
    }
});

function setLanguage(clientLanguage): void {
    switch(clientLanguage) { 
        case ClientLanguage.German: { 
           locStrings.setLanguage('de');
           break; 
        } 
        case ClientLanguage.English: { 
           locStrings.setLanguage('en'); 
           break; 
        } 
        // Otherwise "clientLanguage" is "ClientLanguage.BrowserSetting" and language used is browser setting dependent.
    } 
}

export const Schema = (clientLanguage) => Yup.object().shape({
    terms: Yup.bool()
        .when("InformationIsRequired", {
            is: () => true,
            then: (schema) => {
                setLanguage(clientLanguage);
                return schema.required().oneOf([true], locStrings.dataProtectionRulesRequired);
              },
        }),
});

export const PrivacyConsentSubForm = ({ form: { values, handleBlur, handleChange, touched, errors }, ...props }) => {
    const { dataSecurityUrl, clientLanguage } = props;

    setLanguage(clientLanguage);

    return (
        <>
            <Form.Group controlId="privacyConsent">
                <Form.Check
                    required
                    name="terms"
                    type="checkbox"
                    onChange={handleChange}
                    isInvalid={touched.terms && !!errors.terms}
                    feedback={errors.terms}
                    feedbackType="invalid"
                    label={<span className={"FormDataProtectionRules"} >{locStrings.formatString(locStrings.dataProtectionRulesRead, { dataProtectionRulesLink: <a href={dataSecurityUrl} target="_blank" rel="noreferrer" >{locStrings.dataProtectionRules}</a> })}</span>}
                >
                </Form.Check>
            </Form.Group>
        </>
    );
};